:host {
  --ch-window-offset-x: 0px;
  --ch-window-offset-y: 0px;
  --ch-window-separation-x: 0px;
  --ch-window-separation-y: 0px;
  --ch-window-x-outside: 0px;
  --ch-window-y-outside: 0px;
}

:host(:not([hidden])) {
  display: contents;
}

:host(:is(:not([modal]), [modal="false"])) .mask {
  pointer-events: none;
}

.window {
  pointer-events: all;
}

.mask {
  display: flex;
  position: fixed;
  inset: 0;
  left: calc( var(--ch-window-inset-inline-start) + var(--ch-window-offset-x) + var(--ch-window-separation-x) );
  inset-block-start: calc( var(--ch-window-inset-block-start) + var(--ch-window-offset-y) + var(--ch-window-separation-y) );
  width: var(--ch-window-mask-width);
  height: var(--ch-window-mask-height);
  z-index: var(--ch-window-mask-z-index, 1000);
}
:host(:is([x-align="outside-start"], [x-align="inside-start"])) .mask {
  justify-content: flex-start;
}
:host([x-align=center]) .mask {
  justify-content: center;
}
:host(:is([x-align="outside-end"], [x-align="inside-end"])) .mask {
  justify-content: flex-end;
}
:host(:is([y-align="outside-start"], [y-align="inside-start"])) .mask {
  align-items: flex-start;
}
:host([y-align=center]) .mask {
  align-items: center;
}
:host(:is([y-align="outside-end"], [y-align="inside-end"])) .mask {
  align-items: flex-end;
}

.window {
  display: flex;
  flex-direction: column;
  transform: translate(var(--ch-window-x-outside), var(--ch-window-y-outside)) translate(var(--ch-window-x-drag, 0px), var(--ch-window-y-drag, 0px));
  z-index: inherit;
}
:host([x-align=outside-start]) .window {
  --ch-window-x-outside: -100%;
}
:host([x-align=outside-end]) .window {
  --ch-window-x-outside: 100%;
}
:host([y-align=outside-start]) .window {
  --ch-window-y-outside: -100%;
}
:host([y-align=outside-end]) .window {
  --ch-window-y-outside: 100%;
}

.separation {
  position: fixed;
  inset: 0;
  pointer-events: all;
}
.separation--x {
  top: var(--ch-window-inset-block-start);
  width: var(--ch-window-separation);
  height: var(--ch-window-mask-height);
}
.separation--y {
  left: var(--ch-window-inset-inline-start);
  width: var(--ch-window-mask-width);
  height: var(--ch-window-separation);
}
.separation--both {
  width: calc(var(--ch-window-separation) * 4);
  height: calc(var(--ch-window-separation) * 4);
}
:host([x-align=outside-start]) .separation {
  left: calc( var(--ch-window-inset-inline-start) - var(--ch-window-separation) );
}
:host([x-align=outside-start]) .separation--both {
  left: calc( var(--ch-window-inset-inline-start) - var(--ch-window-separation) * 3 );
}
:host([x-align=outside-end]) .separation {
  left: calc( var(--ch-window-inset-inline-start) + var(--ch-window-mask-width) );
}
:host([x-align=outside-end]) .separation--both {
  left: calc( var(--ch-window-inset-inline-start) + var(--ch-window-mask-width) - var(--ch-window-separation) );
}
:host([y-align=outside-start]) .separation {
  top: calc(var(--ch-window-inset-block-start) - var(--ch-window-separation));
}
:host([y-align=outside-start]) .separation--both {
  top: calc( var(--ch-window-inset-block-start) - var(--ch-window-separation) * 3 );
}
:host([y-align=outside-end]) .separation {
  top: calc( var(--ch-window-inset-block-start) + var(--ch-window-mask-height) );
}
:host([y-align=outside-end]) .separation--both {
  top: calc( var(--ch-window-inset-block-start) + var(--ch-window-mask-height) - var(--ch-window-separation) );
}